/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'
import PlayerHeader from '../PlayerHeader'
import CTVRegistrationBanner from '../CTVRegistrationBanner'
import AlertBanner from '../AlertBanner'
import styles from './styles'
import { ClientOnly } from '..'

const PageHeader = ({
  groupToken,
  loginService,
  currentDomain,
  currentUrl,
  hostname,
  layout,
  alertData,
  isLoading,
}) => {
  const headerRef = useRef(null)
  const { cookieSeen } = useSelector(state => state.cookiePolicyAcceptance)
  let lastScroll = 0

  const makeSticky = () => {
    const currentScroll = window.pageYOffset
    const headerHeight = headerRef.current?.clientHeight
    const offset = (headerHeight / 2)

    if (Math.abs(currentScroll - lastScroll) >= offset) {
      if (currentScroll <= 0) {
        headerRef.current.classList.remove('scroll-up')
      }

      if (currentScroll > lastScroll && lastScroll >= 0 && !headerRef.current.classList.contains('scroll-down')) {
        headerRef.current.classList.remove('scroll-up')
        headerRef.current.classList.add('scroll-down')
      }

      if (currentScroll < lastScroll && headerRef.current.classList.contains('scroll-down')) {
        headerRef.current.classList.remove('scroll-down')
        headerRef.current.classList.add('scroll-up')
      }
      lastScroll = currentScroll
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', makeSticky)
  }, [])

  const showOnMobile = isMobile ? cookieSeen : true

  const renderCTVBanner = (false && layout === 'home' && isMobile)

  return (
    <header ref={headerRef} className={'PageHeader sticky-header'} data-swiftype-index="false">
      {(renderCTVBanner) ? (
        <ClientOnly>
          <CTVRegistrationBanner
            currentDomain={currentDomain}
          />
        </ClientOnly>
      ) : null}
      {layout !== 'standAlonePage'
        ? (
          <PlayerHeader
            groupToken={groupToken}
            hostname={hostname}
            sponsor={layout !== 'featured'}
            menuType={layout === 'featured' ? 'featured' : 'default'}
            currentUrl={currentUrl}
            isLoading={isLoading}
            currentDomain={currentDomain}
            loginService={loginService}
            renderCTVBanner={renderCTVBanner}
          />
        ) : null}
      {((alertData) && (alertData !== {}) && (showOnMobile))
        && (
          <div className="alert-container">
            <AlertBanner
              data={alertData}
            />
          </div>
        )}
      <style jsx>{styles}</style>
    </header>
  )
}

PageHeader.propTypes = {
  groupToken: PropTypes.string,
  loginService: PropTypes.shape({
    logOut: PropTypes.func,
  }).isRequired,
  isLoading: PropTypes.bool,
  currentDomain: PropTypes.string.isRequired,
  currentUrl: PropTypes.string.isRequired,
  hostname: PropTypes.string.isRequired,
  layout: PropTypes.string,
  alertData: PropTypes.array,
}

PageHeader.defaultProps = {
  layout: 'default',
  groupToken: '0071',
  alertData: [],
  isLoading: false,
}

export default PageHeader
